import { Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import { AppAuthMode } from '@features/authentication/types/AppAuthMode';
import { selectAppAuthMode } from '@features/authentication/store/selectors';
import { LoginPage } from '@features/authentication/login-page/LoginPage';
import { ErrorPage } from '@features/authentication/error-page/ErrorPage';



export const AuthorizedPage = () => {

	const appAuthMode = useSelector(selectAppAuthMode);

	if (appAuthMode === AppAuthMode.authFailed) {
		return <ErrorPage />;
	}

	if (appAuthMode === AppAuthMode.authStart) {
		return <LoginPage />;
	}

	return <Outlet />;
}